import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'achievementPercentage' } )
export class AchievementPercentageCalculationPipe implements PipeTransform {

    transform( pTarget: number, pAchievement: number ): string {
        let percentage = 0;
        if (pTarget < 0 || pTarget == null){
            pTarget = 0;
        }
        if (pAchievement < 0 || pAchievement == null){
            pAchievement = 0;
        }
        percentage = (pAchievement / pTarget) * 100;
        if (percentage == Infinity || isNaN(percentage)) {
            percentage = 0;
        }
        return (percentage.toFixed(2));
    }
}
